/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'CUSTOMER_AND_OR_LEGAL_REQUIREMENTS_FOR_RAW_MATERIALS_IDENTIFICA',
              'RAW_MATERIAL_SUPPLY_CHAIN_POLICY_APPLICABLE_TO_SUPPLIERS_SUBCON',
              'RISK_ASSESSMENT_TO_DIFFERENTIATE_HIGH_RISK_MATERIALS_WITHIN_THE',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_are_included_win_the_facs_written_14: valueSchema,
  },
}
